import { Entity } from './types'

export const headerCellsProps = {
  [Entity.Count]: { alignLeft: true, width: 50 },
  [Entity.Category]: { alignLeft: true, width: 200 },
  [Entity.Date]: { alignCenter: true },
  [Entity.Total]: { alignRight: true, width: 100 },
}

export const createHeaderCellsProps = () => {
  return new Proxy(headerCellsProps, {
    get: function (target, property) {
      const res = target[property as string]
      if (!res) {
        return headerCellsProps[Entity.Date]
      }
      return res || {}
    },
  })
}
